<template>
<div class="component">

    <div class="modal is-active">
        <div class="modal-background" @click="closeModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Neues Projekt</p>
                <button class="delete" aria-label="close" @click="closeModal()"></button>
            </header>
            <section class="modal-card-body">
            <div class="newProjectInput">
                    <input class="input" type="text" placeholder="Projektname" v-model="newProjectName">
                     <input class="input" type="text" placeholder="Beschreibung" v-model="newProjectDescription">
</div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="saveProject()">Speichern</button>
                <button class="button" @click="closeModal()">Abbrechen</button>
            </footer>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'NewProjectModal',
    props: [],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            newProjectName:"",
            newProjectDescription:"",
        }
    },
    methods: {
        closeModal(){
            this.newProjectName = "";
            this.newProjectDescription = "";
            this.$emit("close")
        },
        saveProject(){
            if(this.newProjectName==""){
                return;
            }
            let projectObject = {"projectName":this.newProjectName,"description":this.newProjectDescription}
            this.callApi("/project/create","post",projectObject).then(function(response){
                this.refresh();
                this.closeModal();
            }.bind(this))
        },
        refresh(){
            this.$emit("refresh")
        }
    },
    computed: {},
}
</script>

<style scoped>
.newProjectInput{
    width:80%;
    margin:auto;
}
.newProjectInput input{
    margin-bottom:2vh;
}
</style>
